module.exports = __webpack_public_path__ + "static/media/hero-cookie-box.d2f60ba0.png";